<template>
  <a class="logo" data-track-text="logo.sanitas" :href="logoHref">
    <img :src="logo" width="124px" height="30px" />
  </a>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    logoHref: {
      type: String,
      required: true,
    },
  },
  computed: {
    logo() {
      return require('../../../assets/logo.svg')
    },
  },
}
</script>

<style lang="postcss" scoped>
.logo {
  &:hover {
    border-bottom: 0;
  }
}

.logo img {
  display: inline-block;
  width: 61px;
  height: 15px;
  background-size: contain;
  margin-top: var(--action-elements-spacing);
}

@media (--md) {
  .logo img {
    width: 124px;
    height: 30px;
  }
}
</style>
